import { component } from 'picoapp';



import choozy from 'utils/choozy';
// Utils
import { ariaExpandToggle } from 'utils/node';
import { dispatch } from 'utils/theme';



import getProductData from '../../utils/get-product-data';


export default component((node, ctx) => {
  const { grid, wrapper, colorName, option: options = [] } = choozy(node);
  const { showMoreBtn: showMoreBtns = [] } = choozy(node, true);

  const defaultName = colorName.textContent;

  let timeout = null;

  node.addEventListener('click', (e) => {
    if (!showMoreBtns.includes(e.target)) return;

    wrapper.style.maxHeight = `${wrapper.offsetHeight}px`;
    node.classList.add('open');
    wrapper.style.maxHeight = `${grid.offsetHeight + 1}px`;

    [].concat(showMoreBtns).forEach(ariaExpandToggle);

    dispatch('pdp-show-more-color-options');
  });

  [].concat(options).forEach((el) => {
    el.addEventListener('mouseenter', () => {
      clearTimeout(timeout);

      colorName.textContent = el.dataset.option;
    });
    el.addEventListener('mouseleave', () => {
      timeout = setTimeout(() => {
        colorName.textContent = defaultName;
      }, 100);
    });
  });

  const colorHandles = [].concat(options).map(el => el.querySelector('a').href.split('/').pop());
  const savedSelectionKey = `selectedOption-${colorHandles.sort().join(',')}`;

  function updateLinkedUrl() {
    if (sessionStorage.getItem(savedSelectionKey)) {
      const savedSelection = JSON.parse(sessionStorage.getItem(savedSelectionKey));
      const searchStr = savedSelection.join('%');
      [].concat(options).forEach(el => {
        const a = el.querySelector('a');
        const variantData = el.querySelector('script') ? JSON.parse(el.querySelector('script').innerHTML) : null;

        if (a && variantData && variantData[searchStr]) {
          const href = new URL(a.href);

          if (variantData[searchStr].includes('true')) {
            href.searchParams.set('variant', variantData[searchStr].split(':')[0]);
          } else {
            href.searchParams.delete('variant');
          }

          a.href = href.toString();
        }
      })
    }
  }

  updateLinkedUrl();

  document.addEventListener('product:form:update', (e) => {
    const props = e.detail;
    const { currentProductId } = props;
    const { forms } = ctx.getState();
    const { selectedVariant } = forms[currentProductId];

    if (!selectedVariant) return;

    const optionsWithMultipleOptions = forms[currentProductId].fieldsets.filter(i => i.options.length > 1).map(i => i.options.find(o => o.checked));
    const selectedOptions = optionsWithMultipleOptions.map(i => `${i.name}|${i.value}`);

    sessionStorage.setItem(savedSelectionKey, JSON.stringify(selectedOptions));
    updateLinkedUrl();
  })
});
